import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { IonicVue } from '@ionic/vue';

import App from './App.vue';
import router from './router';
import { setNavigateToLogin, setOnRefreshSuccess } from './api/http';
import { syncBiometricRefreshToken } from './composables/useBiometricAuth';
import { resetSession } from './composables/useSessionReset';
import { initFirebase } from './services/firebase';
import { bootstrapNativePlugins } from './services/native';

import './assets/styles/main.css';
import './assets/styles/style.css';

async function bootstrap() {
  const app = createApp(App);
  const pinia = createPinia();

  app.use(pinia);
  app.use(IonicVue, {
    rippleEffect: true,
    mode: 'ios',
  });
  app.use(router);

  // Fire-and-forget: Firebase init & native plugin bootstrap don't block UI.
  void initFirebase();
  void bootstrapNativePlugins();

  await router.isReady();

  // Give the HTTP layer a way to redirect to login when refresh fails,
  // without a circular import between http.ts and the router.
  // Full cleanup mirrors manual logout: reset in-memory state + clear localStorage.
  setNavigateToLogin(async () => {
    await resetSession();
    const biometricEnabled = localStorage.getItem('biometric_enabled');
    localStorage.clear();
    if (biometricEnabled) localStorage.setItem('biometric_enabled', biometricEnabled);
    router.replace({ name: 'login' });
  });
  setOnRefreshSuccess(syncBiometricRefreshToken);

  app.mount('#app');
}

void bootstrap();
